import React from "react";
import styled from "styled-components";
import { tokens } from "../../theme/tokens";

// EmptyState — friendly placeholder for empty tables/lists/errors.
//
//   <EmptyState title="No riders yet" description="Add your first rider."
//               icon={<Icon/>} action={<Button>Add rider</Button>} />

const { colors, radii, spacing, typography } = tokens;

const Root = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    gap: ${spacing[3]};
    padding: ${spacing[7]} ${spacing[5]};
`;

const IconWrap = styled.div`
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 64px;
    height: 64px;
    border-radius: ${radii.xl};
    background: ${colors.rose};
    color: ${colors.primary};
    margin-bottom: ${spacing[1]};
    svg { width: 30px; height: 30px; }
`;

const Title = styled.h4`
    margin: 0;
    font-family: ${typography.fonts.body};
    font-size: ${typography.size.lg};
    font-weight: ${typography.weight.bold};
    color: ${colors.heading};
`;

const Desc = styled.p`
    margin: 0;
    max-width: 42ch;
    font-size: ${typography.size.base};
    line-height: ${typography.leading.normal};
    color: ${colors.muted};
`;

const Actions = styled.div`
    margin-top: ${spacing[2]};
    display: flex;
    gap: ${spacing[2]};
`;

const DefaultIcon = (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden>
        <path
            d="M4 7h16v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V7Zm0 0 2-3h12l2 3M9 12h6"
            stroke="currentColor"
            strokeWidth="1.6"
            strokeLinecap="round"
            strokeLinejoin="round"
        />
    </svg>
);

export default function EmptyState({ icon, title, description, action, ...rest }) {
    return (
        <Root {...rest}>
            <IconWrap>{icon || DefaultIcon}</IconWrap>
            {title && <Title>{title}</Title>}
            {description && <Desc>{description}</Desc>}
            {action && <Actions>{action}</Actions>}
        </Root>
    );
}
